import { Component, Input } from '@angular/core';
import { FiltersComponent } from 'src/app/common/filters.component';

@Component({
	selector: 'app-resident-sold-reservation-filters',
	templateUrl: './resident-sold-reservation-filters.component.html',
	styleUrls: ['./resident-sold-reservation-filters.component.css'],
})
export class ResidentSoldReservationFiltersComponent extends FiltersComponent {
	@Input() users;
	filters = {
		createdBy: null,
		dateFrom: null,
		dateTo: null,
	};
}
